import { toast } from '@/components/toast';
import { useAnalytics } from '@/services/analytics';
import { useCampaign } from '@/services/api';
import { useFlag } from '@/services/featureFlags';
import { creditsToVideoMinutes } from '@/state/credits/credits';
import { AppRoutes } from '@/utils/types';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const ErrorToMessage: { [key: string]: string } = {
    CampaignNotFound: `Promotion doesn't exist.`,
    CampaignExpired: 'Promotion expired.',
    CampaignUsed: 'Promotion already used.',
};

const ErrorPrefix = 'Could not access promotion. ';

const Friends = () => {
    const { pathname } = useLocation();
    const navigate = useNavigate();
    const mixpanel = useAnalytics();
    const creditsToMinutesEnabled = useFlag('credits_to_minutes_enabled', false);

    const getCampain = async (campaignId: string) => {
        try {
            const result = await useCampaign(campaignId);
            mixpanel?.track('campaign', { event: 'success', name: campaignId, credits: result.credits });
            toast.success({
                title: creditsToMinutesEnabled
                    ? `You got ${creditsToVideoMinutes(result.credits)} new minutes 🎉 Let's create something now`
                    : `You got ${result.credits} new credits 🎉 Let's create something now`,
            });
            navigate(AppRoutes.Home);
        } catch (err: any) {
            const errorKind = err?.response?.data?.kind;
            let msg = ErrorPrefix;
            if (errorKind && ErrorToMessage[errorKind]) {
                msg += ErrorToMessage[errorKind];
            }
            mixpanel?.track('campaign', { event: 'error', error: errorKind || 'Unknown', name: campaignId });

            toast.error({ title: msg });
            navigate(AppRoutes.Home);
        }
    };

    useEffect(() => {
        const campaignId = pathname.split('/').pop() ?? '';

        if (!campaignId) {
            toast.error({ title: ErrorPrefix });
        }

        getCampain(campaignId);
    }, []);

    return null;
};
export default Friends;
